const isSlideShowOrArticle = (document.querySelectorAll('.article-wrapper, #slide-show-v2').length > 0);
const loggedIn = (window.top.getAuthLevel() == 2);
const monthNames = ['January', 'Febuary', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
let ranOnce = false;
let isInitialized = false;
let profileMap = {};
let mouseLeaveEvent = null;
let mouseLeaveTimeout;

/* Utility functions */
function insertAfter(newNode, existingNode) {
	if (existingNode != null && newNode != null) {
		existingNode.parentNode.insertBefore(newNode, existingNode.nextSibling);
	}
}	
function strToDom(str) {
	let wrapDiv = document.createElement('div');
	wrapDiv.innerHTML = str;
	return wrapDiv.firstChild;
}
function getClosest(elem, selector) {
	// Get the closest matching parent element
	for ( ; elem && elem !== document; elem = elem.parentNode ) {
		if ( elem.matches( selector ) ) return elem;
	}
	return null;
}
/* // Utility functions */

/* Article + Slideshow layer functions */
function displayComments() {	
	document.body.classList.add('modal-layer-on');
	document.querySelector('#whiteoutlayer, .whiteoutlayer').classList.add('active');
	document.getElementById('comments-layer').classList.add('active');
	wmdTrack('ar-comm-view');
	wmdPageview(trackurl + '_comments', '1');
	if (document.getElementById('whiteoutlayer') != null) {
		document.getElementById('whiteoutlayer').removeAttribute('style');
    }
}
window.displayComments = displayComments;

function hideComments() {
	document.body.classList.remove('modal-layer-on');
	document.querySelector('#whiteoutlayer, .whiteoutlayer').classList.remove('active');
	document.getElementById('comments-layer').classList.remove('active');
	wmdTrack('ar-comm_trtrn');
	wmdPageview(trackurl, '1');
}

function copyCountHtml() {	
	if (document.querySelector('#all__button_2 .vf-badge') != null) { // If comment count is present in Viafoura HTML, copy it for layer header
		document.querySelector('#comments-layer .layer-header h3').innerHTML = document.querySelector('#comments-layer .layer-header h3').innerHTML + ' (<span class="viafoura-commentcount comment-number" data-vf-article-id="' + window.top.DFPTargetKeys.pageSegVars.art + '" data-vf-section-uuid="' + window.top.vfUuid + '">' + document.querySelector('#all__button_2 .vf-badge').innerText.trim() + '</span>)';
	}	
}

function appendCustomElem() {			
	insertAfter(document.getElementById('commentTerms'), document.querySelector('.vf-content-focus-container'));
	insertAfter(document.getElementById('newCommentTerms'), document.querySelector('.vf-content-focus-container'));
	insertAfter(document.getElementById('commentLoginLink'), document.querySelector('.vf-content-focus-container'));
	if (document.getElementById('commentLoginLink') != null && document.querySelector('#loggedout_user_links a[href*=login]') != null) {
		document.getElementById('commentLoginLink').querySelector('a').href = window.top.document.querySelector('#loggedout_user_links a[href*=login]').href;
	}
	if (window.top.document.querySelector('.user-links-settings') != null && window.top.document.querySelector('.user-links-settings').innerText.indexOf('Welcome') == -1) {		
		insertAfter(strToDom('<div class="vf-displayname">' + window.top.document.querySelector('.user-links-settings').innerText + '</div>'), document.querySelector('.vf-comment-header'));
	}
}

function commentReplyCB() {
	window.top.wmdPageLink('ar-comm-post');
	
	if (document.querySelector('#comments-layer .layer-header h3') != null && document.querySelector('#comments-layer .layer-header h3 .viafoura-commentcount') == null) {
		document.querySelector('#comments-layer .layer-header h3').innerHTML = document.querySelector('#comments-layer .layer-header h3').innerHTML + ' (<span class="viafoura-commentcount comment-number" data-vf-article-id="' + window.top.DFPTargetKeys.pageSegVars.art + '" data-vf-section-uuid="' + window.top.vfUuid + '"></span>)';
	}
	setTimeout(window.top.vfCommentCount, 500);
}
/* // Article + Slideshow layer functions */

function closeProfile(e) {
	document.body.removeEventListener('click', clickOutToClose);
	e.target.removeEventListener('mouseleave', clickOutToClose);
	document.querySelector('.profile-card').removeEventListener('mouseleave', clickOutToClose);
	document.removeEventListener('mousemove', checkElemAfterMouseLeave);
	if (document.querySelector('.show-profile-layer') != null) {		
		document.querySelector('.show-profile-layer').classList.remove('show-profile-layer');
	}
}

function execCheckElemAfterMouseLeave(e) {
	if (getClosest(document.elementFromPoint(e.clientX, e.clientY), '.vf-post-name-button, .vf-post-details__time, .profile-card, .vf-reply-to, .vf-content-layout__left') == null) {
		closeProfile(mouseLeaveEvent);
	}
}

function checkElemAfterMouseLeave(e) {
	clearTimeout(mouseLeaveTimeout);
	mouseLeaveTimeout = setTimeout(function() {
		execCheckElemAfterMouseLeave(e);
	}, 200)
}

function clickOutToClose(e) {
	if (e.type == 'click') {
		if (getClosest(e.target, '.profile-card') == null) {
			e.stopPropagation();
			e.preventDefault();
			closeProfile(e);
		}
	} else if (e.type == 'mouseleave') {		
		mouseLeaveEvent = e;
		document.addEventListener('mousemove', checkElemAfterMouseLeave);
	}
}

function bindLayerClose(elem) {
	document.body.removeEventListener('click', clickOutToClose);
	elem.removeEventListener('mouseleave', clickOutToClose);
	document.querySelector('.profile-card').removeEventListener('mouseleave', clickOutToClose);
	document.body.addEventListener('click', clickOutToClose);
	if (breakpoint >= 3) {	
		elem.addEventListener('mouseleave', clickOutToClose);
		document.querySelector('.profile-card').addEventListener('mouseleave', clickOutToClose);	
	}	
}

function showProfileCard(profile, elem) {
	if (!document.querySelector('.profile-card')) {		
		// Construct card content
		const content = `<div class="profile-wrap">
		<div class="profile-overlay"></div>
		<div class="profile-card">
		<span class="profile-avatar"></span>
		<div class="profile-info">
			<span class="profile-author"></span>
			<span class="profile-profession"></span>
			<span class="profile-specialty"></span>
			<span class="profile-location"></span>
			<span class="profile-date"></span>
		</div>
		<div class="close-btn"><a href="javascript:void(0)">X</a></div>
		</div>
		</div>`;
		// Append newly created card element to the container
		getClosest(elem, '.vf-thread, .vf3-comment:not(.vf3-comment--collapsed)').appendChild(strToDom(content));
		document.querySelector('.profile-wrap .close-btn').addEventListener('click', closeProfile);
		bindLayerClose(elem);
	} else {
		getClosest(elem, '.vf-thread, .vf3-comment:not(.vf3-comment--collapsed)').appendChild(document.querySelector('.profile-wrap'));
		bindLayerClose(elem);
	}	
	document.querySelector('.profile-card .profile-avatar').innerHTML = profile.fn.charAt(0) + profile.ln.charAt(0);
	if (profile.degdesc && profile.degdesc !== undefined) {
		document.querySelector('.profile-author').innerHTML = profile.fn + ' ' + profile.ln + ', ' + profile.degdesc;
	} else {
		document.querySelector('.profile-author').innerHTML = profile.fn + ' ' + profile.ln;
	}
	if (profile.profdesc && profile.profdesc !== undefined) {
		document.querySelector('.profile-profession').innerHTML = profile.profdesc;
	} else {
		document.querySelector('.profile-profession').innerHTML = '';
	}
	if (profile.spdesc && profile.spdesc !== undefined) {
		document.querySelector('.profile-specialty').innerHTML = profile.spdesc;
	} else {
		document.querySelector('.profile-specialty').innerHTML = '';
	}	
	if (profile.stdesc && profile.stdesc !== undefined && profile.codesc  && profile.codesc !== undefined) {
		document.querySelector('.profile-location').innerHTML = profile.stdesc + ', ' + profile.codesc;
	} else if (profile.stdesc && profile.stdesc !== undefined) {
		document.querySelector('.profile-location').innerHTML = profile.stdesc;
	} else if (profile.codesc && profile.codesc !== undefined) {
		document.querySelector('.profile-location').innerHTML = profile.codesc;
	} else {
		document.querySelector('.profile-location').innerHTML = '';
	}
	if (profile.crdt && profile.crdt !== undefined) {
		document.querySelector('.profile-date').innerHTML = 'Member Since ' + profileDateFormat(profile.crdt);
	} else {
		document.querySelector('.profile-date').innerHTML = '';
	}
	getClosest(elem, '.vf-thread, .vf3-comment:not(.vf3-comment--collapsed)').classList.add('show-profile-layer');
	window.top.wmdPageLink('uc-prof_hover', elem);
}

function profileDateFormat(d) {
    let t = new Date(d.replace(/ /g, 'T'));
    return monthNames[t.getMonth()] + ' ' + t.getFullYear();
}

function handleProfileClick(elem, userData) {
	if (userData && userData.social_login_id) {
		if (profileMap[userData.social_login_id]) {
			showProfileCard(profileMap[userData.social_login_id], elem);
		} else {
			const reqBody = {
				'id': encodeURIComponent(userData.social_login_id)
			}
			fetch('//' + window.location.host + '/api/v1/communityprofile', {
				method: 'POST',
				mode: 'cors',
				cache: 'no-cache',
				credentials: 'include',
				headers: {
					'Content-Type': 'application/json; charset=utf-8'
				},
				body: JSON.stringify(reqBody)
			}).then(response => response.json()).then(function (json) {
				if (json && json.profile) {
					profileMap[userData.social_login_id]=json.profile;
					showProfileCard(json.profile, elem);
				}
			}).catch((e) => { console.log(e); });
		}
	}
}

function bindVfLoginSignUp() {
	window.vf.$prepublish((channel, event, ...args) => {
		let arg = args;
		let lang = 'en';
		if (typeof locale == 'string' && locale !== '' && locale !== 'us') {
			lang = locale;
		}
		if (channel === 'authentication' && event === 'needed' && (arg[0] != undefined && arg[0].method === 'login') && lang !== '') {
			let url = window.top.document.querySelector('#loggedout_user_links a[href*=login]').href;
			window.top.location.href = url;
		} else if (channel === 'authentication' && event === 'needed' && (arg[0] != undefined && arg[0].method === 'signup') && lang !== '') {
			let url = window.top.document.querySelector('#loggedout_user_links a[href*=regist]').href;
			window.top.location.href = url;
		} else {
			return { channel, event, args };
		}
	});	
	window.vf.$subscribe('authentication', 'logout', () => {
		window.top.location.href = window.top.document.querySelector('.user-popup-menu-link[href*=logout]').href;
	});
}

function runComments() { // Append VF JS and bind 'initializeCB' callback
	if (typeof window.top.vf == 'undefined') {
		window.vfQ = window.vfQ || [];
		window.vfQ.push(initializeCB);	
		const el = document.createElement('script');
		el.async = true;
		el.defer = true;
		el.setAttribute('src', '//cdn.viafoura.net/vf-v2.js');
		document.body.appendChild(el);
	} else {
		vf.context.reset();
		isInitialized = true;
	}	
	if (!loggedIn) {
		document.querySelector('.viafoura').classList.add('logged-out');
	} else {
		document.querySelector('.viafoura').classList.add('logged-in');
	}
}

function initializeCB() { // VF JS initialized callback handler

	isInitialized = true; // Prevent double-firing

	vf.context.get('user').then((user) => {	// If user is logged-out of Medscape but still logged into Viafoura, log them out
		if (!loggedIn && user.user_privilege != 'guest') {
			window.viafoura.session.logout();
		}
	});
	
	// bindVfLoginSignUp();  // Bind VF login/sign-up links to Medscape login/register workflows
	
	window.vf.$subscribe('comment', 'created', commentReplyCB); // Bind callback functions for comment/reply creation
	window.vf.$subscribe('comment-reply', 'posted', commentReplyCB);
	window.vf.$subscribe('commenting', 'loaded', function() {
		appendCustomElem(); // Add commenting-terms and other custom elements			
	});
	window.vf.$subscribe('profile', 'show', handleProfileClick);
	
	if (isSlideShowOrArticle) { // Article + Slideshow layer-related code
		/* if (typeof Medscape == 'object' && typeof Medscape.ArticlePage == 'object' && Medscape.ArticlePage.type != 'DEFAULT') { // If ReCAP or FFQ skip layer logic
			return;
		} */
		document.querySelector('.comments-layer .layer-header svg').addEventListener('click', hideComments); // Bind Layer Close
		window.vf.$subscribe('commenting', 'loaded', function() {
			copyCountHtml(); // Copy comment-count from VF HTML	
		});
	}
}

if (isSlideShowOrArticle) { // Deferred Load
	window.initComments = function() {
		if (typeof vf == 'undefined' && !ranOnce) {
			ranOnce = true;
			runComments();			
			displayComments();
		}
		else if (isInitialized) {
			displayComments();
		}
	}
} else { // Auto-initialize for Standalone
	runComments();
}